import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { getAppointmentById } from "../../../services/doctors";

import { useToast } from "../../../components/ui/use-toast";
import { useAuth } from "../../../contexts/auth-context";

export function useAppointmentById(apptId: Number | undefined) {
  const { toast } = useToast();

  const { mobile } = useAuth();

  const {
    data: appointment,
    isLoading,
    isError,
    isFetched,
  } = useQuery({
    queryKey: ["appointment-details-by-id", apptId],
    queryFn: () => getAppointmentById(apptId),
    enabled: !!mobile && !!apptId,
    retry: 0,
  });
  useEffect(() => {
    if (isError && apptId) {
      toast({
        title: "Failed to fetch appointment details",
        variant: "destructive",
      });
    }
  }, [isError, toast, apptId]);

  return { appointment, isLoading, isFetched };
}
